import { useState, useEffect } from "react";

import { Liferay } from './common/services/liferay/liferay.js';
import api from './common/services/liferay/api.js';
import { InformeSostenibilidad } from './common/components/InformeSostenibilidad';
import { Filters } from "./common/components/Filters";

export const App = ({ contentStructureId, aniosCategoryId, showFirstOpen }) => {
    const [anios, setAnios] = useState([]);
    const [informes, setInformes] = useState([]);
    const [filterInformes, setFilterInformes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Filtramos los informes por anio o resetemaos a los ultimos 4 anios
    const getInformes = (selectedAnio, allAnios = anios, allInformes = informes) => {

        const yearMap = allAnios.reduce((acc, a) => {
            acc[String(a.id)] = parseInt(a.name, 10);
            return acc;
        }, {});

        let filteredInformes = [];

        if (!selectedAnio) {
            // Obtener los 4 últimos años válidos
            const years = allAnios
                .map(a => parseInt(a.name, 10))
                .filter(year => !isNaN(year))
                .sort((a, b) => b - a);

            const latestYears = years.slice(0, 4);
            const latestYearCategoryIds = allAnios
                .filter(a => latestYears.includes(parseInt(a.name, 10)))
                .map(a => a.id);

            filteredInformes = allInformes.filter(informe =>
                informe.taxonomyCategoryBriefs?.some(brief =>
                    latestYearCategoryIds.includes(String(brief.taxonomyCategoryId))
                )
            );
        } else {
            filteredInformes = allInformes.filter(informe =>
                informe.taxonomyCategoryBriefs?.some(
                    brief => String(brief.taxonomyCategoryId) === String(selectedAnio.id)
                )
            );
        }

        //Ordenar por año (descendente)
        filteredInformes.sort((a, b) => {
            const yearA = Math.max(
                ...(a.taxonomyCategoryBriefs || []).map(brief => yearMap[String(brief.taxonomyCategoryId)] || 0)
            );
            const yearB = Math.max(
                ...(b.taxonomyCategoryBriefs || []).map(brief => yearMap[String(brief.taxonomyCategoryId)] || 0)
            );
            return yearB - yearA; // Descendente
        });

        setFilterInformes(filteredInformes);
        return filteredInformes;
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            try {
                const [aniosRes, informesRes] = await Promise.all([
                    api(`o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${aniosCategoryId}/taxonomy-categories`)
                        .then((res) => res.json()),
                    api(`o/headless-delivery/v1.0/content-structures/${contentStructureId}/structured-contents`)
                        .then((res) => res.json()),
                ]);

                const aniosData = aniosRes.items || [];
                const informesData = informesRes.items || [];

                setAnios(aniosData);
                setInformes(informesData);

                const filtered = getInformes(null, aniosData, informesData);
                setFilterInformes(filtered);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [contentStructureId, aniosCategoryId]);

    useEffect(() => {
        if (isLoading) return;

        const accordions = document.querySelectorAll(".aena-dynamic-accordion");

        accordions.forEach((accordion) => {
            const triggers = accordion.querySelectorAll(".acc-trigger");

            triggers.forEach((trigger) => {
                const newTrigger = trigger.cloneNode(true);
                trigger.replaceWith(newTrigger);

                newTrigger.addEventListener("click", () => {
                    const isExpanded = newTrigger.getAttribute("aria-expanded") === "true";
                    const panelId = newTrigger.getAttribute("aria-controls");
                    const panel = document.getElementById(panelId);

                    newTrigger.setAttribute("aria-expanded", String(!isExpanded));
                    panel.classList.toggle("is-open", !isExpanded);
                });
            });
        });
    });

    const handleSearch = (selectedAnio) => {
        getInformes(selectedAnio);
    };

    return (
        <div className="aena-searcher">
            <Filters aniosCategoryId={aniosCategoryId} anios={anios} onSearch={handleSearch} />

            {isLoading ? (
                <div></div>
            ) : (
                <section className="aena-grid-container">
                    <ul className="aena-accordion aena-dynamic-accordion">
                        {filterInformes?.map((informe, index) => (
                            <InformeSostenibilidad key={informe.id} informe={informe} index={index} showFirstOpen={showFirstOpen} />
                        ))}
                    </ul>
                </section>
            )}
        </div>
    );
};
